import http from '@utils/request'
import ls from '@utils/localStore'
import apiPath from './api-path'

// // 获取登录手机号的账户列表 (个人 + 机构)
// export const getMgAccounts = phone => http.get({
//     url: `/op/pc/loginCheck?phone=${ phone }`
// })

const { mgApi } = apiPath
const resetMgUid = (params = {}) => {
    return {
        ...params,
        projectUid: apiPath.mgUid // 民革项目uid
    }
}

// 登录成功后，使用 token 获取四类用户角色
export const getMgAccounts = () => http.get({
    url: '/op/minge/role'
})

// 获取登录账户的民革项目列表（党员之家 + 支部）
export const getMgProjects = userUid => http.get({
    url: `/op/pc/project?userUid=${userUid}`
})

// 获取该项目下的权限
export const getMgPermissions = params => http.get({
    url: '/op/minge/score/auth',
    params
})

// 获取该账户下的支部id
export const getMemberDetailApi = () => http.get({
    url: `/op/minge/branch/detail/forOrg?targetUsername=${ls.get('userInfo').targetUsername}`
})

// 获取支部表格的下载模板地址
export const getTemplateDownloadUrl = () => http.get({
    url: `/op/common/templete?type=mgzb&targetUsername=${ls.get('userInfo').targetUsername}`
})

// 支部手册下载
export const downloadBranchPdf = params => http.get({
    url: '/op/mingeWorkbook/download',
    params: {
        ...params,
        targetUsername: ls.get('userInfo').targetUsername,
        branchUid: ls.get('BRANCHID')
    },
    responseType: 'blob'
})

// 获取省市区列表
export const getCityListApi = params => http.get({
    url: '/custom/cities',
    params,
    baseURL: apiPath.imAPI
})

// 查党员之家支部用
export const getHomeListApi = params => http.get({
    url: '/op/minge/home/forBranch',
    params: {
        ...params,
        projectUid: ls.get('PROJECTUID'),
        targetUsername: ls.get('userInfo').targetUsername
    }
})

// 查党员列表
export const getMemberListApi = params => http.get({
    url: '/op/minge/branch/member/list',
    params: {
        ...params,
        projectUid: ls.get('PROJECTUID'),
        branchUid: ls.get('BRANCHID')
    }
})

// 查党员之家列表
export const getPartyListApi = params => http.get({
    url: '/op/minge/home',
    params: {
        ...params,
        projectUid: ls.get('PROJECTUID'),
        targetUsername: ls.get('userInfo').targetUsername
    }
})

// 删除党员之家
export const delPartyHome = uid => http.delete({
    url: `/op/minge/home?uid=${uid}&targetUsername=${ls.get('userInfo').targetUsername}`
})

// 示范支部列表
export const getExampleListApi = params => http.get({
    url: '/op/minge/branch/list',
    params: {
        ...params,
        targetUsername: ls.get('userInfo').targetUsername
    }
})

/** 示范支部回头看 — 列表（查询参数与 branch/list 类似：keyword、省市区、branchState、分页 from/size 等） */
export const getLookbackListApi = data => http.post({
    url: '/op/minge/branch/look/list',
    data,
    baseURL: mgApi
})

/** 示范支部回头看 — 审核操作：auditStatus 0 撤销审核，1 审核，3 退回；id 为列表记录 id，多个逗号拼接 */
export const LOOKBACK_BATCH_AUDIT_STATUS = Object.freeze({
    revoke: 0,
    audit: 1,
    return: 3
})

export const batchOperateLookbackApi = data => http.post({
    url: '/op/minge/branch/look/audit',
    data,
    baseURL: mgApi
})

/**
 * 示范支部回头看 — 情况表详情（填报项 + 得分）
 * @param {{ branchUid: string, id?: string|number }} params branchUid 必填；id 为列表记录 id，按后端约定选传
 */
export const getLookbackDetailApi = branchUid => http.get({
    url: `/op/minge/branch/look/detail/${branchUid}`,
    baseURL: mgApi
})

/**
 * 示范支部回头看 — 单项填报即时得分
 * @param {{ id: number|string, value: string|number, branchUid?: string }} data id 为题号 key；value 为当前填报值
 */
export const getLookbackItemScoreApi = params => http.get({
    url: '/op/minge/branch/look/score',
    params,
    baseURL: mgApi
})

/** 示范支部回头看保存：与 saveLookbackApi 第二参数配合 */
export const LOOKBACK_SAVE_MODE = Object.freeze({
    add: 'add',
    edit: 'edit'
})

/**
 * 示范支部回头看 — 保存（新增 / 编辑同一入参，按 mode 走不同地址）
 * @param {{ branchUid: string, records: Array<{ itemId: number|string, itemValue: string|number }> }} data
 * @param {'add'|'edit'} mode LOOKBACK_SAVE_MODE.add / LOOKBACK_SAVE_MODE.edit
 */
export const saveLookbackApi = (data, mode) => {
    const url = mode === LOOKBACK_SAVE_MODE.edit
        ? '/op/minge/branch/look/edit'
        : '/op/minge/branch/look/add'
    return http.post({
        url,
        data,
        baseURL: mgApi
    })
}

// 删除支部
export const delBranchHome = uid => http.delete({
    url: `op/minge/branch/${uid}`
})

// 示范支部审核
export const authExampleApi = data => http.post({
    url: '/op/minge/branch/audit',
    data: {
        ...data,
        targetUsername: ls.get('userInfo').targetUsername
    }
})

// 党员之家详情
export const getPartyDetailHome = () => http.get({
    url: `/op/minge/home/forOrg?targetUsername=${ls.get('userInfo').targetUsername}`
})

// 党员之家详情 - 上级查看
export const getPartyDetail = uid => http.get({
    url: `/op/minge/home/${uid}`
})

// 党员之家审核
export const passParty = data => http.put({
    url: '/op/minge/home/audit',
    data: {
        ...data,
        targetUsername: ls.get('userInfo').targetUsername
    }
})

// 党员之家 - 新增
export const addPartyHome = data => http.post({
    url: '/op/minge/home',
    data: {
        ...data,
        targetUsername: ls.get('userInfo').targetUsername
    }
})

// 党员之家 - 编辑
export const editPartyHome = data => http.put({
    url: '/op/minge/home',
    data: {
        ...data,
        projectUid: ls.get('PROJECTUID'),
        targetUsername: ls.get('userInfo').targetUsername
    }
})

// 党员之家 - 活动列表
export const getHomeActivityListApi = params => http.get({
    url: '/op/minge/home/event',
    params
})

// 党员之家 - 添加活动
export const addHomeActivity = data => http.post({
    url: '/op/minge/home/event',
    data: {
        ...data,
        targetUsername: ls.get('userInfo').targetUsername
    }
})

// 党员之家 - 编辑活动
export const editHomeActivity = data => http.put({
    url: '/op/minge/home/event',
    data: {
        ...data,
        targetUsername: ls.get('userInfo').targetUsername
    }
})

// 党员之家 - 删除活动
export const delHomeActivity = uid => http.delete({
    url: `/op/minge/home/event?uid=${uid}&targetUsername=${ls.get('userInfo').targetUsername}`
})

// 党员之家 - 提交到中央
export const submitCenter = data => http.put({
    url: '/op/minge/home/submitCenter',
    data: {
        ...data,
        targetUsername: ls.get('userInfo').targetUsername
    }
})

// 民革项目 - 普通用户列表
export const getOrdinaryList = () => http.get({
    url: '/op/user/getOrdinaryUser',
    params: resetMgUid({
        from: 1,
        size: 9999
    })
})

// 民革项目 - 管理员列表
export const getManagerList = () => http.get({
    url: '/op/user/getManager',
    params: resetMgUid({
        from: 1,
        size: 9999
    })
})

// 民革项目 - 添加云服问题
export const addProblem = data => http.post({
    url: '/op/question/submit',
    data: resetMgUid(data)
})

// 民革项目 - 编辑云服问题
export const updateProblem = data => http.put({
    url: '/op/question/update',
    data: resetMgUid(data)
})

// 民革项目 - 云服问题列表
export const getProblems = params => http.get({
    url: '/op/question',
    params: resetMgUid(params)
})

// 民革项目 - 删除云服问题
export const delProblem = uid => http.delete({
    url: `/op/question/delete/${uid}`
})

// 民革项目 - 云服问题详情
export const getProblemDetail = id => http.get({
    url: `/op/question/${id}`
})

// 民革项目 - 根据当前角色获取可见范围列表
export const getRoleSeeRange = () => http.get({
    url: '/op/question/match/tree/minge?type=2'
})

// 民革项目 - 预警列表
export const getReminds = params => http.get({
    url: '/op/minge/remind',
    params
})

// 新增支部基础信息
export const createBranchBaseInfo = data => http.post({
    url: '/op/minge/branch/create/baseInfo',
    data: resetMgUid(data)
});

// 新增党员之家基础信息
export const createHomeBaseInfo = data => http.post({
    url: '/op/minge/home/create/baseInfo',
    data: resetMgUid(data)
});

// 编辑支部账号
export const editBranchContact = data => http.post({
    url: '/op/minge/branch/edit/contact',
    data: resetMgUid(data)
});

// 编辑党员之家账号
export const editHomeContact = data => http.post({
    url: '/op/minge/home/edit/contact',
    data: resetMgUid(data)
});

